import { render, staticRenderFns } from "./commodityNote.vue?vue&type=template&id=a2ae8762&scoped=true&"
import script from "./commodityNote.vue?vue&type=script&lang=js&"
export * from "./commodityNote.vue?vue&type=script&lang=js&"
import style0 from "./commodityNote.vue?vue&type=style&index=0&id=a2ae8762&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ae8762",
  null
  
)

export default component.exports